import React from "react";
import {observable} from "mobx";
import CreateIcon from "@material-ui/icons/Create";
import {Values} from "@src/Tools/Values";
import {Organisation} from "@src/Interfaces/Entity/Organisation";
import {inject, observer} from "mobx-react";
import {IManagementStore} from "@src/Stores/Management/types";
import {
    OrganisationDialog
} from "@src/Components/Pages/Main/Content/Organisations/OrganisationsContent/OrganisationDialog/OrganisationDialog";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
    org: Organisation;
    management?: IManagementStore;
}

@inject("management")
@observer
export default class OrganisationEdit extends React.Component<IProps> {
    @observable editOpened: boolean = false;

    handleUpdate = async (values: Organisation) => {
        await this.props.management.saveOrganisation(values);
        this.editOpened = false;
    };

    handleOpenEdit = () => {
        this.editOpened = true;
    };
    handleCloseEdit = () => {
        this.editOpened = false;
    };

    render() {
        return (
            <React.Fragment>
                <RoundButton
                    icon={<CreateIcon/>}
                    tooltipTitle={Values.getLocalizationValue("edit")}
                    onClick={() => this.handleOpenEdit()}
                />
                
                {this.editOpened &&
                    <OrganisationDialog
                        onClose={() => this.editOpened = false}
                        isOpened={this.editOpened}
                        organisation={this.props.org}
                        isEdit={true}
                    />
                }
            </React.Fragment>
        );
    }
}
